import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 bg-background-50">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            探索论坛板块
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto">
            八大主题板块，覆盖技术、生活、数码、游戏、职场、汽车、健康、财经等热门话题
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group bg-background-100 border border-background-200/70 rounded-lg p-5 hover:border-primary-300 hover:bg-background-50 transition-all text-center"
            >
              <div className={`w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl ${
                cat.color === 'primary' ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-600'
              } group-hover:scale-110 transition-transform`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 font-heading">{cat.name}</h3>
              <p className="text-xs text-foreground-500 mb-2 line-clamp-1">{cat.description}</p>
              <div className="flex items-center justify-center gap-3 text-xs text-foreground-400">
                <span>{cat.articleCount.toLocaleString()} 帖</span>
                <span>·</span>
                <span>今日 {cat.todayPosts}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}